/**
 * Configuration for the Proximity API V2
 */
export default {
	id: 'proximityV2',
	name: 'Proximity',
	resultsTitle: 'Recommendations',
	version: 'v2',
	fields: [
		{
			name: 'Content Id',
			placeholder: 'Enter ID for source document E.g. tardisnyc/realsimple_343433 or 4843036',
			required: true,
			value: '',
			id: 'id',
			type: 'text',
		},
		{
			name: 'Source Vertical/Brand',
			placeholder: 'Required for recommendations for Selene content ids',
			required: false,
			maxTags: 1,
			value: null,
			id: 'source',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Order By',
			required: false,
			value: 'Relevance',
			id: 'orderBy',
			type: 'select',
			options: [
				{
					value: 'Relevance',
					name: 'Relevance',
				},
				{
					value: 'PublishedDate',
					name: 'Published Date',
				},
				{
					value: 'Recent',
					name: 'Recent',
				},
				{
					value: 'Popularity',
					name: 'Popularity',
				},
				{
					value: 'Popularity7Days',
					name: 'Popularity 7 Days',
				},
				{
					value: 'Popularity30Days',
					name: 'Popularity 30 Days',
				},
				{
					value: 'LastUpdatedDate',
					name: 'Most recently updated first',
				},
				{
					value: 'AverageRating',
					name: 'Content ordered by average rating from high to low',
				},
				{
					value: 'LastOptimizedDate',
					name: 'Most recently optimized if newer than published first',
				},
				{
					value: 'ReviewsCount',
					name: 'Content ordered by reviews count from high to low',
				},
			],
		},
		{
			name: 'Content-types',
			placeholder: 'Enter content types...',
			required: false,
			value: null,
			id: 'docTypeFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/types',
		},
		{
			name: 'Sources',
			placeholder: 'Enter sources...',
			required: false,
			value: null,
			id: 'sourceFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Variants',
			placeholder: 'Enter variants...',
			required: false,
			value: null,
			id: 'variantFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/variants',
		},
		{
			name: 'Meredith User Id',
			placeholder: 'Enter User Id',
			required: false,
			value: '',
			id: 'muid',
			type: 'text',
		},
		{
			name: 'Exclude',
			placeholder: 'Enter excluded ids...',
			required: false,
			value: null,
			id: 'excludeIds',
			type: 'csv',
		},
		{
			name: 'Syndicated',
			required: false,
			id: 'syndicated',
			type: 'select',
			options: [
				{
					value: 'All',
					name: 'All',
				},
				{
					value: 'BrandExclusive',
					name: 'BrandExclusive',
				},
				{
					value: 'DoNotSyndicate',
					name: 'DoNotSyndicate',
				},
				{
					value: 'Branded',
					name: 'Branded',
				},
				{
					value: 'Native',
					name: 'Native',
				},
				{
					value: 'ExternalOnly',
					name: 'ExternalOnly',
				},
				{
					value: 'None',
					name: 'None',
				},
				{
					value: 'ContentLicensing',
					name: 'ContentLicensing',
				},
				{
					value: 'Unknown',
					name: 'Unknown',
				},
			],
		},
		{
			name: 'Start Date',
			placeholder: 'Click to select a start date',
			required: false,
			value: null,
			id: 'startDate',
			type: 'datetime',
		},
		{
			name: 'End Date',
			placeholder: 'Click to select an end date',
			required: false,
			value: null,
			id: 'endDate',
			type: 'datetime',
		},
		{
			name: 'Page',
			placeholder: 'Page',
			required: false,
			value: 1,
			id: 'page',
			type: 'page',
		},
		{
			name: 'Page Size',
			placeholder: 'Size',
			required: false,
			value: 20,
			id: 'pageSize',
			type: 'pageSize',
		},
	],
};
